export const LOADER_UNIDAD_NODES = 'LOADER_UNIDAD_NODE';
export const SAVE_LOADER_UNIDAD_NODE = 'SAVE_LOADER_UNIDAD_NODE';
export const GET_UNIDAD_NODES = 'GET_UNIDAD_NODES';
export const UNIDAD_NODE_FAIL = 'UNIDAD_NODE_FAIL';
export const UNIDAD_NODE_FORM_FAIL = 'UNIDAD_NODE_FORM_FAIL';